import {
  type ConnectWorkflowNodeCategory,
  type ConnectWorkflowNodePaletteItem
} from '../../../services/connect/connect-nodes.service';

export const CONNECT_WORKFLOW_NODE_CATEGORIES: readonly ConnectWorkflowNodeCategory[] = ['Triggers', 'Logic', 'Integrations', 'Utils'];

export const CONNECT_WORKFLOW_CORE_NODE_TYPES: readonly ConnectWorkflowNodePaletteItem[] = [
  {
    paletteId: 'trigger.manual',
    workflowType: 'trigger.manual',
    label: 'Manual Trigger',
    description: 'Start manually with predefined data',
    category: 'Triggers',
    defaults: {
      ref: 'system.trigger.manual',
      input: {static: {}, body: {}, query: {}},
    },
  },
  {
    paletteId: 'trigger.webhook',
    workflowType: 'trigger.webhook',
    label: 'Webhook Trigger',
    description: 'Start via API call (body/query captured)',
    category: 'Triggers',
    defaults: {
      ref: 'webhook.ingest',
      input: {static: {}},
    },
  },
  {
    paletteId: 'trigger.scheduled',
    workflowType: 'trigger.scheduled',
    label: 'Scheduled Trigger',
    description: 'Start on a schedule with predefined data',
    category: 'Triggers',
    defaults: {
      ref: 'system.trigger.scheduled',
      input: {static: {}, body: {}, query: {}},
    },
  },
  {
    paletteId: 'api.http',
    workflowType: 'api.http',
    label: 'API Request',
    description: 'Make an API call',
    category: 'Integrations',
    defaults: {
      ref: 'http.request',
      input: {method: 'GET', url: ''},
    },
  },
  {
    paletteId: 'api.connector',
    workflowType: 'api.connector',
    label: 'Connector Action',
    description: 'Perform an action via connector',
    category: 'Integrations',
    defaults: {
      ref: 'connector.action',
      input: {},
    },
  },
  {
    paletteId: 'ai.chat',
    workflowType: 'ai.chat',
    label: 'AI Chat',
    description: 'Chat completion via AI gateway',
    category: 'Integrations',
    defaults: {
      ref: 'openai.chat',
      ['x-ai']: {instructions: ''},
    },
  },
  {
    paletteId: 'ai.embedding',
    workflowType: 'ai.embedding',
    label: 'AI Embedding',
    description: 'Create embeddings via AI gateway',
    category: 'Integrations',
    defaults: {
      ref: 'openai.embedding',
      ['x-ai']: {instructions: ''},
    },
  },
  {
    paletteId: 'ai.reranker',
    workflowType: 'ai.reranker',
    label: 'AI Reranker',
    description: 'Rerank results via AI gateway',
    category: 'Integrations',
    defaults: {
      ref: 'cohere.rerank',
      ['x-ai']: {instructions: ''},
    },
  },
    {
    paletteId: 'control.condition',
    workflowType: 'control.condition',
    label: 'Condition',
    description: 'Branch based on conditions',
    category: 'Logic',
    defaults: {
      ref: 'system.condition',
      condition: {expression: 'true'},
    },
  },
  {
    paletteId: 'control.loop',
    workflowType: 'control.loop',
    label: 'Loop',
    description: 'Iterate over items',
    category: 'Logic',
    defaults: {
      ref: 'system.loop',
      loop: {collection: '$.items'},
    },
  },
  {
    paletteId: 'control.wait',
    workflowType: 'control.wait',
    label: 'Wait',
    description: 'Pause until time or condition',
    category: 'Logic',
    defaults: {
      ref: 'system.wait',
      wait: {delay_ms: 1000},
    },
  },
  {
    paletteId: 'control.transform',
    workflowType: 'control.transform',
    label: 'Transform',
    description: 'Map and reshape data',
    category: 'Logic',
    defaults: {
      ref: 'system.transform',
      transform: {language: 'jq', expression: '.'},
    },
  },
  {
    paletteId: 'control.join',
    workflowType: 'control.join',
    label: 'Join',
    description: 'Synchronize branches',
    category: 'Logic',
    defaults: {
      ref: 'system.join',
      join: {strategy: 'all'},
    },
  },
  {
    paletteId: 'control.parallel',
    workflowType: 'control.parallel',
    label: 'Parallel',
    description: 'Fan-out to parallel branches',
    category: 'Logic',
    defaults: {
      ref: 'system.parallel',
    },
  },
];

export const CONNECT_WORKFLOW_NODE_TYPES: readonly ConnectWorkflowNodePaletteItem[] = [
  ...CONNECT_WORKFLOW_CORE_NODE_TYPES,
];
